import getSiblings from '../helpers/siblings';

class SubmenuToggle {
  constructor(options = {}) {
    this.config = {
      rootModule: document.querySelector('[data-module="Header"]'),
      module: document.querySelectorAll('[data-module="SubmenuToggle"]'),
      menus: document.querySelectorAll('[data-module="Menu"]'),
      desktopMenuBreakpoint: 992,
      openUrlOnToggle: false,
      ...options
    };
  }

  get isDesktopMenu() {
    return window.innerWidth >= this.config.desktopMenuBreakpoint;
  }

  init() {
    const { module, menus } = this.config;

    if (!module.length || !menus.length) {
      return;
    }

    module.forEach(submenuToggle => {
      const parent = submenuToggle.parentNode;

      submenuToggle.addEventListener('touchend', this.toggle.bind(this));
      submenuToggle.addEventListener('click', this.toggle.bind(this));
      parent.addEventListener('mouseover', this.open.bind(this));
      parent.addEventListener('mouseout', this.close.bind(this));
    });

    window.addEventListener('resize', this.reset.bind(this));
    document.addEventListener('click', this.onDocumentClick.bind(this));
  }

  destroy() {
    const { module } = this.config;

    this.reset();

    module.forEach(submenuToggle => {
      const parent = submenuToggle.parentNode;

      submenuToggle.removeEventListener('touchend', this.toggle.bind(this));
      submenuToggle.removeEventListener('click', this.toggle.bind(this));
      parent.removeEventListener('mouseover', this.open.bind(this));
      parent.removeEventListener('mouseout', this.close.bind(this));
    });

    window.removeEventListener('resize', this.reset.bind(this));
    document.removeEventListener('click', this.onDocumentClick.bind(this));
  }

  getMenu(el) {
    if (el === this.config.rootModule) {
      return null;
    }

    if (el.dataset.module && el.dataset.module === 'Menu') {
      return el;
    }

    return this.getMenu(el.parentNode);
  }

  onDocumentClick(e) {
    const { module, menus } = this.config;

    let normalLinks = [];

    menus.forEach(menu => {
      normalLinks = [
        ...normalLinks,
        ...menu.querySelectorAll('a:not([data-module="SubmenuToggle"])')
      ];
    });

    if (
      !Array.from(module).find(submenuToggle => submenuToggle === e.target) &&
      !Array.from(normalLinks).find(normalLink => normalLink === e.target)
    ) {
      module.forEach(submenuToggle => submenuToggle.parentNode.classList.remove('is-open'));
    }
  }

  reset() {
    const { module } = this.config;

    module.forEach(submenuToggle => submenuToggle.parentNode.classList.remove('is-open'));
  }

  toggle(e) {
    const { menus, openUrlOnToggle } = this.config;
    const parent = e.target.parentNode;

    e.preventDefault();

    if (e.target.dataset.hasNestedSubmenu) {
      e.stopPropagation();
    }

    if (
      parent.classList.contains('is-open') &&
      openUrlOnToggle &&
      e.target.dataset.disableUrl === undefined
    ) {
      window.open(e.target.getAttribute('href'), e.target.getAttribute('target') || '_self');
    }

    parent.classList.toggle('is-open');
    parent.querySelectorAll('.is-open').forEach(child => child.classList.remove('is-open'));

    getSiblings(parent).forEach(sibling => {
      sibling.classList.remove('is-open');
      sibling.querySelectorAll('.is-open').forEach(child => child.classList.remove('is-open'));
    });

    menus.forEach(menu => {
      if (menu !== this.getMenu(e.target)) {
        menu.querySelectorAll('.is-open').forEach(el => el.classList.remove('is-open'));
      }
    });
  }

  open(e) {
    if (this.isDesktopMenu) {
      e.preventDefault();
      e.currentTarget.classList.add('is-open');
    }
  }

  close(e) {
    if (this.isDesktopMenu) {
      e.preventDefault();
      e.currentTarget.classList.remove('is-open');
    }
  }
}

export default SubmenuToggle;
